import { Component } from "@angular/core";
import { faUpload, faBroom } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CoeBiddingResultsService } from "src/app/services/autopac/coe-bidding-results.service";
import { NotifierService } from "angular-notifier";

@Component({
  selector: "app-coe-bidding-results",
  templateUrl: "./coe-bidding-results.component.html",
  styleUrls: ["./coe-bidding-results.component.css"],
})
export class CoeBiddingResultsComponent {
  faUpload = faUpload;
  faBroom = faBroom;
  file!: ArrayBuffer;
  fileName: string = "";
  enableUpload: boolean = false;

  selectCOE: FormField[] = [
    {
      type: "select",
      id: "Status",
      label: "Select type",
      options: [
        { display: "Successful COE", value: "Successful" },
        { display: "Unsuccessful COE", value: "Unsuccessful" },
      ],
      value: "Successful",
    },
  ];

  TableHeaders = [
    {
      title: "NO",
      type: "data",
      id: "No",
    },
    {
      title: "SALES CONSULTANT",
      type: "data",
      id: "SalesConsultant",
    },
    {
      title: "CONTRACT NO",
      type: "data",
      id: "ContractNo",
    },
    {
      title: "BUYER'S NAME",
      type: "data",
      id: "BuyerName",
    },
    {
      title: "MODEL",
      type: "data",
      id: "Model",
    },
    {
      title: "F6",
      type: "data",
      id: "F6",
    },
    {
      title: "F7",
      type: "data",
      id: "F7",
    },
    {
      title: "F8",
      type: "data",
      id: "F8",
    },
    {
      title: "F9",
      type: "data",
      id: "F9",
    },
    {
      title: "COLOUR",
      type: "data",
      id: "Colour",
    },
    {
      title: "CONTRACT NUMBER",
      type: "data",
      id: "ContractNumber",
    },
    {
      title: "VIN NUMBER",
      type: "data",
      id: "VinNumber",
    },
    {
      title: "STATUS",
      type: "data",
      id: "Status",
    },
    {
      title: "FINANCE COMPANY",
      type: "data",
      id: "FinanceCompany",
    },
    {
      title: "REMARKS",
      type: "data",
      id: "Remarks",
    },
  ];
  TableEntries: any[] = [];

  constructor(
    private coeBiddingResultsService: CoeBiddingResultsService,
    private notifier: NotifierService,
  ) {}

  updateFields(event: any) {
    this.selectCOE = event.fields;
  }

  onFileChange(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;

    if (target.files.length !== 1) {
      console.error("Please, upload only one file");
      return;
    }

    const file = target.files[0];
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const arrayBuffer: ArrayBuffer = e.target.result;

      this.enableUpload = true;
      this.fileName = file.name;
      this.file = arrayBuffer;
    };

    reader.readAsArrayBuffer(file);
  }

  ShowFile(): void {
    this.TableEntries = [];
    this.coeBiddingResultsService
      .UploadFiles(this.file, this.fileName)
      .subscribe({
        next: ({ body }) => {
          if (body.Code === 0) {
            this.TableEntries = [...this.TableEntries, ...body.Data];
          } else {
            console.log(body);
          }
        },
        error: console.error,
      });
  }

  clear(): void {
    this.TableEntries = [];
  }

  update(): void {
    this.coeBiddingResultsService
      .UpdateCOE(this.TableEntries, this.selectCOE[0].value)
      .subscribe({
        next: () =>
          this.notifier.notify(
            "success",
            "COEs were secured for these contracts",
          ),
        error: console.error,
      });
  }
}
